import React, { useEffect, useMemo, useRef, useState } from "react";
import { View, TouchableOpacity, Image, Text, Animated } from "react-native";
import { AppImages } from "../../../../utility/AppImages";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import { AppFontStyle } from "../../../../styles/AppFontStyle";
import withErrorBoundary from "../../../../utility/auth/withErrorBoundary";
import { AppColors } from "../../../../utility/AppColors";
import CardProgressBar from "../Events/CardProgressBar";
import moment from "moment";
import { NotificationButtons } from "./NotificationButtons";
import { ImWatchingPosterImage } from "./ImWatchingPosterImage";
import { formatDate } from "../../../../utility/Index";
import { StackActions } from "@react-navigation/native";
import { navigateToScreen } from "../../../../utility/NavigationHelper";
import { AppScreens } from "../../../Utility/AppScreens";
import Avatar from "../../../../Components/choose-avatar-components/Avatar";
import SvgImage from "../../../../Components/choose-avatar-components/SvgImage";
import { NOTIFICATION_STRINGS } from "../../../../utility/types/stringsConfig";
import NotificationSkeleton from "../../../../Components/skeleton-components/NotificationSkeleton";
import { NOTIFICATION_CATEGORIES } from "../../../../utility/types/NotificationConfig";
// Import our new configuration and components
import {
  REMINDER_HOURS_MAP,
  CHECK_IN_HOURS_MAP,
  REMINDER_SEQUENCE,
  CHECK_IN_SEQUENCE,
  REMINDER_KEYS,
  CHECK_IN_KEYS,
  EVENT_REMINDER_KEYS,
  ACTION_TYPES,
  ACTION_STATUS,
  CATEGORY_STATUS,
  NOTIFICATION_VALUES,
  NOTIFICATION_DIMENSIONS
} from "../../../../config/notificationConfig";
import { useNotificationTiming } from "../../../../hooks/useNotificationTiming";
import { WinnerComponent } from "../../../../Components/notifications/WinnerComponent";

function ChallengeItem({
  item,
  accessToken,
  index,
  handleNotificationResponse,
  selectedButton,
  navigation,
  challengeID,
  setChallengeID,
  setShowNotificationDetails,
  setChallengeItem,
  setShowPendingNotifications,
  notificationReadLoader,
  setConfirmCheckInLoader,
  confirmCheckInLoader,
  getNotificationList,
  setChallengeDetails,
  setUpdatedEventDetails,
  setPreviousEventDetails,
  setUpdatedEventEventId,
  setUpdatedEventNotificationId,
  setShowEventsDetailsUpdatedModal,
  setShowChangesApprovedModal,
  setShowChangesRejectedModal,
  showChangesLoader,
  challengeDetails,
  setShowAcceptModal,
  showAcceptModal,
  setCornfirmPurchaseBeltModal,
  setAcceptLoader,
  handleProfileUpdate,
  markAsSeenById,
  refreshCounts,
  updateNotificationStatus,
  isHighlighted = false,
}) {
  const buttonRef = useRef(null);
  const styles = useStyles();
  const deviceSize = useDeviceSize();
  const [isMinAttendees, setIsMinAttendees] = useState(false);
  const [isMoreTimeLeft, setIsMoreTimeLeft] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isRemoving, setIsRemoving] = useState(false);
  const fadeAnim = useRef(new Animated.Value(1)).current;
  const currentDate = new Date();
  const currentUser = localStorage.getItem("username");

  const timingData = useNotificationTiming(item, selectedButton);
  const { timeLeft, timeLeftOneHour, isLessThan24Hours, noTimeLeft, isMissed, timeLeftUTC } = timingData;

  useEffect(() => {
    setLoading(false);
  }, [item, selectedButton]);

  // SIMPLIFIED: Use hook timing data instead of redundant calculations
  const signUpNumber = NOTIFICATION_VALUES.SIGNUP_NUMBER;
  const requiredNumber = item?.minimumAttendees
    ? Math.max(item.minimumAttendees - signUpNumber, 0)
    : 0;

  useEffect(() => {
    setIsMinAttendees(requiredNumber > signUpNumber);
    // Use hook's timing calculations instead of redundant local timing
    setIsMoreTimeLeft(!noTimeLeft && !isMissed);
  }, [item, requiredNumber, noTimeLeft, isMissed]);
  const handleUserProfilePress = (item) => {
    if (
      item.actionStatus === ACTION_STATUS.SEND &&
      item.actionType === ACTION_TYPES.CHALLENGE_REQUEST
    ) {
      navigateToScreen(navigation, AppScreens.MyProfileWebScreen);
    } else {
      const challengerId = item?.details?.challengerId;
      navigateToScreen(navigation, AppScreens.UserProfile, { username: challengerId });
    }
  };
  const checkInEventMessageText = (item) => {
    switch (item?.actionType) {
      case ACTION_TYPES.ATTENDANCE_REMINDER:
        return (
          {
            [REMINDER_KEYS.REMINDER_24H]:
              NOTIFICATION_STRINGS.ATTENDANCE_REMINDER_24H_MESSAGE,
            [REMINDER_KEYS.REMINDER_12H]:
              NOTIFICATION_STRINGS.ATTENDANCE_REMINDER_12H_MESSAGE,
            [REMINDER_KEYS.REMINDER_6H]: NOTIFICATION_STRINGS.ATTENDANCE_REMINDER_6H_MESSAGE,
            [REMINDER_KEYS.REMINDER_3H]: NOTIFICATION_STRINGS.ATTENDANCE_REMINDER_3H_MESSAGE,
            [REMINDER_KEYS.REMINDER_1H]: NOTIFICATION_STRINGS.ATTENDANCE_REMINDER_1H_MESSAGE,
            [REMINDER_KEYS.FINAL_WARNING]:
              NOTIFICATION_STRINGS.ATTENDANCE_REMINDER_FINAL_WARNING_MESSAGE,
          }[item?.notificationKey] ||
          `${NOTIFICATION_STRINGS.DEFAULT_EVENT_REMINDER}${item?.details?.gameTitle || ""
          }`
        );
      case ACTION_TYPES.CHECK_IN:
        switch (item?.category) {
          case CHECK_IN_KEYS.HALF_HOUR:
            return NOTIFICATION_STRINGS.HALF_HOUR_CHECK_IN_MESSAGE;
          case CHECK_IN_KEYS.ONE_HOUR:
            return NOTIFICATION_STRINGS.ONE_HOUR_CHECK_IN_MESSAGE;
          case CHECK_IN_KEYS.TWO_HOURS:
            return NOTIFICATION_STRINGS.TWO_HOURS_CHECK_IN_MESSAGE;
          case CHECK_IN_KEYS.THREE_HOURS:
            return NOTIFICATION_STRINGS.THREE_HOURS_CHECK_IN_MESSAGE;
          case CHECK_IN_KEYS.FIVE_HOURS:
            return NOTIFICATION_STRINGS.FIVE_HOURS_CHECK_IN_MESSAGE;
          case CHECK_IN_KEYS.SIX_HOURS:
            return NOTIFICATION_STRINGS.SIX_HOURS_CHECK_IN_MESSAGE;
          case CHECK_IN_KEYS.TWELVE_HOURS:
            return NOTIFICATION_STRINGS.TWELVE_HOURS_CHECK_IN_MESSAGE;
          case CHECK_IN_KEYS.TWENTY_FOUR_HOURS:
            return NOTIFICATION_STRINGS.TWENTY_FOUR_HOURS_CHECK_IN_MESSAGE;
          default:
            return `${NOTIFICATION_STRINGS.DEFAULT_EVENT_REMINDER}${item?.details?.gameTitle || ""
              }`;
        }
      default:
        return (
          item?.message ||
          `${NOTIFICATION_STRINGS.DEFAULT_EVENT_REMINDER}${item?.details?.gameTitle || ""
          }`
        );
    }
  };
  const checkInEventHeaderText = (item) => {
    switch (item?.actionType) {
      case ACTION_TYPES.ATTENDANCE_REMINDER:
        return (
          {
            [REMINDER_KEYS.REMINDER_24H]: NOTIFICATION_STRINGS.ATTENDANCE_REMINDER_24H_TITLE,
            [REMINDER_KEYS.REMINDER_12H]: NOTIFICATION_STRINGS.ATTENDANCE_REMINDER_12H_TITLE,
            [REMINDER_KEYS.REMINDER_6H]: NOTIFICATION_STRINGS.ATTENDANCE_REMINDER_6H_TITLE,
            [REMINDER_KEYS.REMINDER_3H]: NOTIFICATION_STRINGS.ATTENDANCE_REMINDER_3H_TITLE,
            [REMINDER_KEYS.REMINDER_1H]: NOTIFICATION_STRINGS.ATTENDANCE_REMINDER_1H_TITLE,
            [REMINDER_KEYS.FINAL_WARNING]:
              NOTIFICATION_STRINGS.ATTENDANCE_REMINDER_FINAL_WARNING_TITLE,
          }[item?.notificationKey] ||
          `${NOTIFICATION_STRINGS.DEFAULT_CHECK_IN_HEADER}${item?.details?.eventTitle || ""
          } in ${item?.details?.gameTitle || ""}`
        );
      case ACTION_TYPES.CHECK_IN:
        switch (item?.category) {
          case CHECK_IN_KEYS.HALF_HOUR:
            return NOTIFICATION_STRINGS.HALF_HOUR_CHECK_IN_HEADER;
          case CHECK_IN_KEYS.ONE_HOUR:
            return NOTIFICATION_STRINGS.ONE_HOUR_CHECK_IN_HEADER;
          case CHECK_IN_KEYS.TWO_HOURS:
            return NOTIFICATION_STRINGS.TWO_HOURS_CHECK_IN_HEADER;
          case CHECK_IN_KEYS.THREE_HOURS:
            return `${NOTIFICATION_STRINGS.THREE_HOURS_CHECK_IN_HEADER}${item?.details?.eventTitle || ""
              } in ${item?.details?.gameTitle || ""}`;
          case CHECK_IN_KEYS.FIVE_HOURS:
            return `${NOTIFICATION_STRINGS.FIVE_HOURS_CHECK_IN_HEADER}${item?.details?.eventTitle || ""
              } in ${item?.details?.gameTitle || ""}`;
          case CHECK_IN_KEYS.TWENTY_FOUR_HOURS:
            return `${NOTIFICATION_STRINGS.TWENTY_FOUR_HOURS_CHECK_IN_HEADER}${item?.details?.eventTitle || ""
              } in ${item?.details?.gameTitle || ""}`;
          default:
            return `${NOTIFICATION_STRINGS.DEFAULT_CHECK_IN_HEADER}${item?.details?.eventTitle || ""
              } in ${item?.details?.gameTitle || ""}`;
        }
      default:
        return (
          item?.messageTitle ||
          `${NOTIFICATION_STRINGS.DEFAULT_CHECK_IN_HEADER}${item?.details?.eventTitle || ""
          } in ${item?.details?.gameTitle || ""}`
        );
    }
  };
  const eventReminderText = (item) => {
    let text = NOTIFICATION_STRINGS.EVENT_REMINDER_WILL_BEGIN_IN;
    switch (item?.category) {
      case EVENT_REMINDER_KEYS.ONE_HOUR:
        text += NOTIFICATION_STRINGS.EVENT_REMINDER_AN_HOUR;
        break;
      case EVENT_REMINDER_KEYS.TWO_HOURS:
        text += NOTIFICATION_STRINGS.EVENT_REMINDER_TWO_HOURS;
        break;
      case EVENT_REMINDER_KEYS.THREE_HOURS:
        text += NOTIFICATION_STRINGS.EVENT_REMINDER_THREE_HOURS;
        break;
      case EVENT_REMINDER_KEYS.FOUR_HOURS:
        text += NOTIFICATION_STRINGS.EVENT_REMINDER_FOUR_HOURS;
        break;
      case EVENT_REMINDER_KEYS.FIVE_HOURS:
        text += NOTIFICATION_STRINGS.EVENT_REMINDER_FIVE_HOURS;
        break;
      case EVENT_REMINDER_KEYS.SIX_HOURS:
        text += NOTIFICATION_STRINGS.EVENT_REMINDER_SIX_HOURS;
        break;
      case EVENT_REMINDER_KEYS.TWELVE_HOURS:
        text += NOTIFICATION_STRINGS.EVENT_REMINDER_TWELVE_HOURS;
        break;
      case EVENT_REMINDER_KEYS.TWENTY_FOUR_HOURS:
        text += NOTIFICATION_STRINGS.EVENT_REMINDER_TWENTY_FOUR_HOURS;
        break;
      default:
        text = NOTIFICATION_STRINGS.EVENT_REMINDER_WILL_BEGIN_SOON;
    }
    return text;
  };
  // WinnerComponent is now extracted to a separate file
  const winnerComponent = useMemo(
    () => <WinnerComponent item={item} selectedButton={selectedButton} />,
    [item, selectedButton]
  );
  const shouldRenderNotification = () => {
    if (selectedButton === "I've Organised") {
      return (
        item.actionType === ACTION_TYPES.CHALLENGE_REQUEST ||
        item.actionType === ACTION_TYPES.EVENT_AWARDED ||
        item.actionType === ACTION_TYPES.EVENT_LOST ||
        // Show cancelled event notifications for organisers
        item.actionType === "checkin_failed" ||
        item.actionType === "no_challenger_selected" ||
        item.actionType === "challenge_response" ||
        item.actionType === "no_response" ||
        // Show audience-alert notifications with completed status for organisers
        (item.actionType === ACTION_TYPES.AUDIENCE_ALERT &&
          item.actionStatus === "completed" &&
          item.category === NOTIFICATION_CATEGORIES.ORGANISER) ||
        ([
          ACTION_TYPES.CHECK_IN,
          ACTION_TYPES.ATTENDANCE_REMINDER,
          ACTION_TYPES.CHALLENGER_CHECK_IN,
          ACTION_TYPES.ORGANISER_CHECK_IN,
          ACTION_TYPES.EVENT_REMINDER,
          ACTION_TYPES.EVENT_UPDATE_STATUS,
          ACTION_TYPES.EVENT_UPDATE,
          ACTION_TYPES.EVENT_UPDATE_BEFORE,
          ACTION_TYPES.ATTENDANCE_MISSED,
          ACTION_TYPES.OPPONENT_ALERT,
          ACTION_TYPES.ACCOUNT_WARNING,
        ].includes(item.actionType) &&
          (item.actionStatus === ACTION_STATUS.PENDING ||
            item.actionStatus === ACTION_STATUS.CONFIRMED ||
            item.actionStatus === "informed" ||
            // Allow check-in notifications with "checked_in" status
            (item.actionStatus === "checked_in" &&
              (item.actionType === ACTION_TYPES.CHALLENGER_CHECK_IN ||
                item.actionType === ACTION_TYPES.ORGANISER_CHECK_IN))) &&
          item?.details?.organiserId === currentUser)
      );
    }
    if (selectedButton === "Challenges") {
      return [
        ACTION_TYPES.CHECK_IN,
        ACTION_TYPES.ATTENDANCE_REMINDER,
        ACTION_TYPES.CHALLENGE_RESPONSE,
        ACTION_TYPES.ACCEPT_REJECT,
        ACTION_TYPES.CHECK_IN_MISSED,
        ACTION_TYPES.ATTENDANCE_MISSED,
        ACTION_TYPES.OPPONENT_ALERT,
        ACTION_TYPES.EVENT_AWARDED,
        ACTION_TYPES.EVENT_LOST,
        ACTION_TYPES.ACCOUNT_WARNING,
        ACTION_TYPES.ORGANISER_CHECK_IN,     // Added: Show organiser check-in to challengers
        ACTION_TYPES.CHALLENGER_CHECK_IN,    // Added: Show challenger check-in notifications
        ACTION_TYPES.AUDIENCE_ALERT,         // Added: Show audience-alert (including completed events)
        ACTION_TYPES.EVENT_UPDATE,           // Added: Show event update notifications
        ACTION_TYPES.EVENT_UPDATE_BEFORE,    // Added: Show event update before acceptance notifications
        "checkin_failed",                    // Added: Show cancelled event notifications
        "no_challenger_selected",            // Added: Show cancelled event notifications
        "no_response",                       // Added: Show cancelled event notifications
      ].includes(item.actionType);
    }
    if (selectedButton === "Im Watching") {
      return (
        item?.category !== CATEGORY_STATUS.COMPLETED ||
        item.actionType === ACTION_TYPES.AUDIENCE_ALERT ||
        // Show cancelled event notifications for audience
        item.actionType === "checkin_failed" ||
        item.actionType === "no_challenger_selected" ||
        item.actionType === "no_response"
      );
    }
    return (
      item?.category !== CATEGORY_STATUS.COMPLETED ||
      item.actionType === ACTION_TYPES.EVENT_AWARDED ||
      item.actionType === ACTION_TYPES.EVENT_LOST
    );
  };
  const renderSkeleton = () => <NotificationSkeleton />;
  return (
    <>
      {shouldRenderNotification() && (
        <>
          {loading ? (
            renderSkeleton()
          ) : (
            <Animated.View
              style={{
                opacity: fadeAnim,
                flexDirection: "column",
                zIndex: NOTIFICATION_VALUES.Z_INDEX,
                paddingHorizontal: NOTIFICATION_DIMENSIONS.card.padding[deviceSize]?.horizontal || NOTIFICATION_DIMENSIONS.card.padding.default.horizontal,
                paddingVertical: NOTIFICATION_DIMENSIONS.card.padding[deviceSize]?.vertical || NOTIFICATION_DIMENSIONS.card.padding.default.vertical,
                borderRadius: NOTIFICATION_VALUES.BORDER_RADIUS,
                marginVertical: NOTIFICATION_DIMENSIONS.card.margin[deviceSize]?.vertical || NOTIFICATION_DIMENSIONS.card.margin.default.vertical,
                marginHorizontal: NOTIFICATION_DIMENSIONS.card.margin[deviceSize]?.horizontal || NOTIFICATION_DIMENSIONS.card.margin.default.horizontal,
                borderWidth: isHighlighted ? 4 : NOTIFICATION_VALUES.BORDER_WIDTH,
                gap: NOTIFICATION_DIMENSIONS.card.gap[deviceSize] || NOTIFICATION_DIMENSIONS.card.gap.default,
                position: "relative",
                // Enhanced styling for highlighted notifications
                backgroundColor: isHighlighted
                  ? 'rgba(255, 255, 255, 0.08)' // Subtle white background for highlighted
                  : 'rgba(220, 38, 38, 0.03)', // Red background for normal
                // Enhanced border styling
                borderColor: isHighlighted
                  ? AppColors.white // Clean white border for highlighted
                  : (item.isSeen === 0 ? '#DC2626' : AppColors.gray_A6A3AA),
                borderLeftWidth: isHighlighted ? 6 : (item.isSeen === 0 ? 6 : 2),
                borderLeftColor: isHighlighted
                  ? AppColors.white // Clean white left border for highlighted
                  : (item.isSeen === 0 ? '#DC2626' : AppColors.gray_A6A3AA),
                flexWrap: "wrap",
                // Enhanced shadow for highlighted notifications
                shadowColor: isHighlighted
                  ? AppColors.white
                  : (item.isSeen === 0 ? '#DC2626' : 'transparent'),
                shadowOpacity: isHighlighted ? 0.3 : (item.isSeen === 0 ? 0.4 : 0),
                shadowRadius: isHighlighted ? 8 : (item.isSeen === 0 ? 6 : 0),
                shadowOffset: isHighlighted
                  ? { width: 0, height: 2 }
                  : (item.isSeen === 0 ? { width: -3, height: 0 } : { width: 0, height: 0 }),
                elevation: isHighlighted ? 8 : (item.isSeen === 0 ? 6 : 0),
                // Add a subtle animation effect for highlighted notifications
                transform: isHighlighted ? [{ scale: 1.02 }] : [{ scale: 1 }],
              }}
            >
              {/* Enhanced notification indicator */}
              {(item.isSeen === 0 || isHighlighted) && (
                <View
                  style={{
                    position: "absolute",
                    top: 12,
                    right: 12,
                    width: isHighlighted ? 12 : 8,
                    height: isHighlighted ? 12 : 8,
                    borderRadius: isHighlighted ? 6 : 4,
                    backgroundColor: isHighlighted
                      ? AppColors.white
                      : '#DC2626',
                    zIndex: 10,
                    // Add subtle glow for highlighted notifications
                    ...(isHighlighted && {
                      shadowColor: AppColors.white,
                      shadowOpacity: 0.6,
                      shadowRadius: 3,
                      shadowOffset: { width: 0, height: 0 },
                      elevation: 6,
                    }),
                  }}
                />
              )}

              <View style={{ justifyContent: "space-between" }}>
                <View
                  style={{
                    flexDirection: "row",
                    gap:
                      deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                        ? 8
                        : 16,
                    alignItems: "flex-start",
                  }}
                >
                  <View style={{ alignItems: "flex-start" }}>
                    {(selectedButton === "I've Organised" ||
                      selectedButton === "Challenges") &&
                      item.category !== CATEGORY_STATUS.COMPLETED ? (
                      <TouchableOpacity
                        onPress={() => handleUserProfilePress(item)}
                      >
                        <View
                          style={[
                            styles.imageComponentStyle,
                            { overflow: "hidden" },
                          ]}
                        >
                          <Avatar
                            src={
                              (selectedButton === "I've Organised"
                                ? (item.actionStatus === ACTION_STATUS.SEND &&
                                  item.actionType === ACTION_TYPES.CHALLENGE_REQUEST
                                  ? item?.details?.participantProfiles[0]
                                    ?.profilePicture
                                  : item?.details?.participantProfiles[1]
                                    ?.profilePicture) ||
                                "https://squadify-avatar.s3.eu-west-2.amazonaws.com/cat.svg"
                                : item?.details?.participantProfiles[0]
                                  ?.profilePicture) ||
                              "https://squadify-avatar.s3.eu-west-2.amazonaws.com/cat.svg"
                            }
                            variant="notificationLargePlayer"
                          />
                        </View>
                      </TouchableOpacity>
                    ) : (
                      <ImWatchingPosterImage
                        item={item}
                        deviceSize={deviceSize}
                      />
                    )}
                  </View>
                  <View
                    style={{
                      alignItems: "flex-start",
                      maxWidth:
                        deviceSize === DEVICE_SIZES.SM ||
                          deviceSize === DEVICE_SIZES.XS
                          ? 200
                          : 600,
                      gap: 8,
                    }}
                  >
                    {[ACTION_TYPES.CHECK_IN, ACTION_TYPES.ATTENDANCE_REMINDER].includes(
                      item.actionType
                    ) ? (
                      item.actionStatus === ACTION_STATUS.PENDING ? (
                        <View
                          style={{
                            flexDirection: "column",
                            maxWidth:
                              deviceSize === DEVICE_SIZES.SM ||
                                deviceSize === DEVICE_SIZES.XS
                                ? 200
                                : 600,
                            gap: 8,
                          }}
                        >
                          <Text
                            style={[
                              styles.strongText,
                              { color: AppColors.white },
                            ]}
                          >
                            {checkInEventHeaderText(item)}
                          </Text>
                          <Text
                            style={[
                              styles.normalText,
                              { color: AppColors.gray_C4C4C4 },
                            ]}
                          >
                            {checkInEventMessageText(item)}
                          </Text>
                        </View>
                      ) : item.actionStatus === ACTION_STATUS.CONFIRMED ? (
                        <View
                          style={{
                            flexDirection: "column",
                            maxWidth:
                              deviceSize === DEVICE_SIZES.SM ||
                                deviceSize === DEVICE_SIZES.XS
                                ? 200
                                : 600,
                            gap: 8,
                          }}
                        >
                          <Text
                            style={[
                              styles.strongText,
                              { color: AppColors.white },
                            ]}
                          >
                            {NOTIFICATION_STRINGS.ATTENDANCE_CONFIRMED_TITLE}
                          </Text>
                          <Text
                            style={[
                              styles.normalText,
                              { color: AppColors.gray_C4C4C4 },
                            ]}
                          >
                            {`${NOTIFICATION_STRINGS.ATTENDANCE_CONFIRMED_MESSAGE} ${item.details.eventTitle}`}
                          </Text>
                        </View>
                      ) : null
                    ) : item.actionType === "attendance-missed" ? (
                      <View
                        style={{
                          flexDirection: "column",
                          maxWidth:
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? 200
                              : 600,
                          gap: 8,
                        }}
                      >
                        <Text
                          style={[
                            styles.strongText,
                            { color: AppColors.white },
                          ]}
                        >
                          {item.messageTitle ||
                            NOTIFICATION_STRINGS.ATTENDANCE_MISSED_TITLE}
                        </Text>
                        <Text
                          style={[
                            styles.normalText,
                            { color: AppColors.gray_C4C4C4 },
                          ]}
                        >
                          {item.message ||
                            `${NOTIFICATION_STRINGS.FAILED_TO_CHECK_IN_ORGANIZER
                            }${item.details?.eventTitle || "an event"},${item.category === "organiser"
                              ? NOTIFICATION_STRINGS.NO_LONGER_ORGANIZER
                              : NOTIFICATION_STRINGS.NO_LONGER_PARTICIPANT
                            }`}
                        </Text>
                      </View>
                    ) : item.actionType === "challenger_check_in" ||
                      item.actionType === "organiser_check_in" ? (
                      <View
                        style={{
                          flexDirection: "column",
                          maxWidth:
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? 200
                              : 600,
                          gap: 8,
                        }}
                      >
                        <Text
                          style={[
                            styles.strongText,
                            { color: AppColors.white },
                          ]}
                        >
                          {`${NOTIFICATION_STRINGS.CHECK_IN_UPDATE_FOR}${item.details.eventTitle}`}
                        </Text>
                        <Text
                          style={[
                            styles.normalText,
                            { color: AppColors.gray_C4C4C4 },
                          ]}
                        >
                          {item.message}
                        </Text>
                      </View>
                    ) : item.actionType === "opponent-alert" ? (
                      <View
                        style={{
                          flexDirection: "column",
                          maxWidth:
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? 200
                              : 600,
                          gap: 8,
                        }}
                      >
                        <Text
                          style={[
                            styles.strongText,
                            { color: AppColors.white },
                          ]}
                        >
                          {NOTIFICATION_STRINGS.OPPONENT_ALERT_TITLE}
                        </Text>
                        <Text
                          style={[
                            styles.normalText,
                            { color: AppColors.gray_C4C4C4 },
                          ]}
                        >
                          {NOTIFICATION_STRINGS.OPPONENT_ALERT_MESSAGE}
                        </Text>
                      </View>
                    ) : item.actionType === "event-awarded" ? (
                      <View
                        style={{
                          flexDirection: "column",
                          maxWidth:
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? 200
                              : 600,
                          gap: 8,
                        }}
                      >
                        <Text
                          style={[
                            styles.strongText,
                            { color: AppColors.white },
                          ]}
                        >
                          {NOTIFICATION_STRINGS.EVENT_AWARDED_TITLE}
                        </Text>
                        <Text
                          style={[
                            styles.normalText,
                            { color: AppColors.gray_C4C4C4 },
                          ]}
                        >
                          {NOTIFICATION_STRINGS.EVENT_AWARDED_MESSAGE}
                        </Text>
                        {winnerComponent}
                      </View>
                    ) : item.actionType === "event-lost" ? (
                      <View
                        style={{
                          flexDirection: "column",
                          maxWidth:
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? 200
                              : 600,
                          gap: 8,
                        }}
                      >
                        <Text
                          style={[
                            styles.strongText,
                            { color: AppColors.white },
                          ]}
                        >
                          {NOTIFICATION_STRINGS.EVENT_LOST_TITLE}
                        </Text>
                        <Text
                          style={[
                            styles.normalText,
                            { color: AppColors.gray_C4C4C4 },
                          ]}
                        >
                          {NOTIFICATION_STRINGS.EVENT_LOST_MESSAGE}
                        </Text>
                        {winnerComponent}
                      </View>
                    ) : item.actionType === "account-warning" ? (
                      <View
                        style={{
                          flexDirection: "column",
                          maxWidth:
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? 200
                              : 600,
                          gap: 8,
                        }}
                      >
                        <Text
                          style={[
                            styles.strongText,
                            { color: AppColors.white },
                          ]}
                        >
                          {NOTIFICATION_STRINGS.ACCOUNT_WARNING_TITLE}
                        </Text>
                        <Text
                          style={[
                            styles.normalText,
                            { color: AppColors.gray_C4C4C4 },
                          ]}
                        >
                          {NOTIFICATION_STRINGS.ACCOUNT_WARNING_MESSAGE}
                        </Text>
                      </View>
                    ) : selectedButton === "I've Organised" ? (
                      <View
                        style={{
                          alignItems: "flex-start",
                          maxWidth:
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? 200
                              : 600,
                        }}
                      >
                        {item.actionType === "event-reminder" ||
                          item.actionType === "challenge_response" ? (
                          item.actionStatus === "pending" ? (
                            <Text style={{ color: AppColors.white }}>
                              <Text style={[styles.normalText]}>
                                {NOTIFICATION_STRINGS.EVENT}&nbsp;
                              </Text>
                              <Text style={[styles.strongText]}>
                                {item.details.eventTitle}&nbsp;
                              </Text>
                              <Text style={[styles.normalText]}>
                                {NOTIFICATION_STRINGS.FOR}&nbsp;
                              </Text>
                              <Text style={[styles.strongText]}>
                                {item.details.gameTitle}&nbsp;
                              </Text>
                              <Text style={[styles.normalText]}>
                                {eventReminderText(item)}
                              </Text>
                            </Text>
                          ) : item.actionType === "challenge_response" &&
                            item.actionStatus === "rejected" ? (
                            <Text style={{ color: AppColors.white }}>
                              <Text style={[styles.strongText]}>
                                {item.details.challengerId}&nbsp;
                              </Text>
                              <Text style={[styles.normalText]}>
                                {
                                  NOTIFICATION_STRINGS.HAS_REJECTED_YOUR_CHALLENGE_IN
                                }
                                &nbsp;
                              </Text>
                              <Text style={[styles.strongText]}>
                                {item.details.gameTitle}
                              </Text>
                            </Text>
                          ) : item.actionType === ACTION_TYPES.CHALLENGE_RESPONSE &&
                            item.actionStatus === ACTION_STATUS.ACCEPTED ? (
                            <Text style={{ color: AppColors.white }}>
                              <Text style={[styles.strongText]}>
                                {item.details.challengerId}&nbsp;
                              </Text>
                              <Text style={[styles.normalText]}>
                                {
                                  NOTIFICATION_STRINGS.HAS_ACCEPTED_YOUR_CHALLENGE_IN
                                }
                                &nbsp;
                              </Text>
                              <Text style={[styles.strongText]}>
                                {item.details.gameTitle}&nbsp;
                              </Text>
                              <Text style={[styles.normalText]}>
                                {NOTIFICATION_STRINGS.FOR_EVENT}&nbsp;
                              </Text>
                              <Text style={[styles.strongText]}>
                                {item?.details?.eventTitle}&nbsp;
                              </Text>
                            </Text>
                          ) : null
                        ) : item.actionType === ACTION_TYPES.CHALLENGE_REQUEST &&
                          item.actionStatus === ACTION_STATUS.SEND ? (
                          <Text style={{ color: AppColors.white }}>
                            <Text style={[styles.normalText]}>
                              {
                                NOTIFICATION_STRINGS.YOU_HAVE_SENT_A_CHALLENGE_TO
                              }
                              &nbsp;
                            </Text>
                            <Text style={[styles.strongText]}>
                              {item?.details?.challengerId}&nbsp;
                            </Text>
                            <Text style={[styles.normalText]}>
                              {NOTIFICATION_STRINGS.IN}&nbsp;
                            </Text>
                            <Text style={[styles.strongText]}>
                              {item?.details?.gameTitle}&nbsp;
                            </Text>
                            <Text style={[styles.normalText]}>
                              {NOTIFICATION_STRINGS.FOR_EVENT}&nbsp;
                            </Text>
                            <Text style={[styles.strongText]}>
                              {item?.details?.eventTitle}&nbsp;
                            </Text>
                          </Text>
                        ) : item.actionType === ACTION_TYPES.EVENT_UPDATE_STATUS ? (
                          <View
                            style={{
                              flexDirection: "column",
                              maxWidth:
                                deviceSize === DEVICE_SIZES.SM ||
                                  deviceSize === DEVICE_SIZES.XS
                                  ? 200
                                  : 600,
                              gap: 8,
                            }}
                          >
                            <Text
                              style={[
                                styles.strongText,
                                { color: AppColors.white },
                              ]}
                            >
                              {item.message}
                            </Text>
                            <Text
                              style={[
                                styles.normalText,
                                { color: AppColors.gray_C4C4C4 },
                              ]}
                            >
                              {`${NOTIFICATION_STRINGS.CHECK_OUT_DETAILS_OF_THE_EVENT} ${item.details.eventTitle}`}
                            </Text>
                          </View>
                        ) : item.actionType === ACTION_TYPES.AUDIENCE_ALERT &&
                          item.actionStatus === "completed" ? (
                          <View
                            style={{
                              flexDirection: "column",
                              maxWidth:
                                deviceSize === DEVICE_SIZES.SM ||
                                  deviceSize === DEVICE_SIZES.XS
                                  ? 200
                                  : 600,
                              gap: 8,
                            }}
                          >
                            <Text
                              style={[
                                styles.strongText,
                                { color: AppColors.white },
                              ]}
                            >
                              {item?.message}
                            </Text>
                            <Text
                              style={[
                                styles.normalText,
                                { color: AppColors.gray_C4C4C4 },
                              ]}
                            >
                              {`${NOTIFICATION_STRINGS.CHECK_OUT_DETAILS_OF_THE_EVENT} ${item.details.eventTitle}`}
                            </Text>
                            {winnerComponent}
                          </View>
                        ) : (item.actionType === "checkin_failed" ||
                          item.actionType === "no_challenger_selected" ||
                          item.actionType === "no_response") ? (
                          <View
                            style={{
                              flexDirection: "column",
                              maxWidth:
                                deviceSize === DEVICE_SIZES.SM ||
                                  deviceSize === DEVICE_SIZES.XS
                                  ? 200
                                  : 600,
                              gap: 8,
                            }}
                          >
                            <Text
                              style={[
                                styles.strongText,
                                { color: AppColors.white },
                              ]}
                            >
                              {`Event Cancelled: ${item?.details?.cancelReason || item?.message || 'Event has been cancelled'}`}
                            </Text>
                            <Text
                              style={[
                                styles.normalText,
                                { color: AppColors.gray_C4C4C4 },
                              ]}
                            >
                              {`${NOTIFICATION_STRINGS.CHECK_OUT_DETAILS_OF_THE_EVENT} ${item.details.eventTitle}`}
                            </Text>
                          </View>
                        ) : item?.category === CATEGORY_STATUS.COMPLETED ? (
                          <View
                            style={{
                              flexDirection: "column",
                              maxWidth:
                                deviceSize === DEVICE_SIZES.SM ||
                                  deviceSize === DEVICE_SIZES.XS
                                  ? 200
                                  : 600,
                              gap: 8,
                            }}
                          >
                            <Text
                              style={[
                                styles.strongText,
                                { color: AppColors.white },
                              ]}
                            >
                              {item?.message}
                            </Text>
                            <Text
                              style={[
                                styles.normalText,
                                { color: AppColors.gray_C4C4C4 },
                              ]}
                            >
                              {`${NOTIFICATION_STRINGS.CHECK_OUT_DETAILS_OF_THE_EVENT} ${item.details.eventTitle}`}
                            </Text>
                            {winnerComponent}
                          </View>
                        ) : null}
                      </View>
                    ) : selectedButton === "Challenges" ? (
                      item.actionType === ACTION_TYPES.ACCEPT_REJECT ? (
                        <View
                          style={{
                            alignItems: "flex-start",
                            maxWidth:
                              deviceSize === DEVICE_SIZES.SM ||
                                deviceSize === DEVICE_SIZES.XS
                                ? 200
                                : 575,
                          }}
                        >
                          <Text style={{ color: AppColors.white }}>
                            <Text style={[styles.strongText]}>
                              {item?.details?.organiserId}&nbsp;
                            </Text>
                            <Text style={[styles.normalText]}>
                              {NOTIFICATION_STRINGS.HAS_SENT_YOU_CHALLENGE_IN}
                            </Text>
                            <Text style={[styles.strongText]}>
                              &nbsp;{item?.details?.gameTitle}
                            </Text>
                          </Text>
                        </View>
                      ) : item.type === 'event_update_before' || item.actionType === ACTION_TYPES.EVENT_UPDATE_BEFORE ? (
                        <View
                          style={{
                            flexDirection: "column",
                            maxWidth:
                              deviceSize === DEVICE_SIZES.SM ||
                                deviceSize === DEVICE_SIZES.XS
                                ? 200
                                : 600,
                            gap: 8,
                          }}
                        >
                          <Text style={{ color: AppColors.white }}>
                            <Text style={[styles.strongText]}>
                              Event Updated by{" "}
                            </Text>
                            <Text style={[styles.normalText, { color: AppColors.white }]}>
                              {item.senderId || item?.details?.organiserId || "Kaller"}
                            </Text>
                          </Text>
                          {item.updatedEventDetails?.summary && item.updatedEventDetails.summary.length > 0 && (
                            <View style={{ marginTop: 4, gap: 4 }}>
                              {item.updatedEventDetails.summary.map(
                                (summaryText: string, idx: number) => (
                                  <Text
                                    key={idx}
                                    style={[
                                      styles.normalText,
                                      {
                                        color: AppColors.gray_C4C4C4,
                                      },
                                    ]}
                                  >
                                    • {summaryText}
                                  </Text>
                                )
                              )}
                            </View>
                          )}
                        </View>
                      ) : item.actionType === ACTION_TYPES.EVENT_UPDATE ? (
                        <View
                          style={{
                            flexDirection: "column",
                            maxWidth:
                              deviceSize === DEVICE_SIZES.SM ||
                                deviceSize === DEVICE_SIZES.XS
                                ? 200
                                : 600,
                            gap: 8,
                          }}
                        >
                          <Text
                            style={[
                              styles.strongText,
                              { color: AppColors.white },
                            ]}
                          >
                            {item.message}
                          </Text>
                          <Text
                            style={[
                              styles.normalText,
                              { color: AppColors.gray_C4C4C4 },
                            ]}
                          >
                            {item.actionStatus === ACTION_STATUS.PENDING
                              ? NOTIFICATION_STRINGS.CHECK_OUT_THE_UPDATED_DETAILS_OF_THE_EVENT
                              : item.actionStatus === ACTION_STATUS.REJECTED
                                ? `${NOTIFICATION_STRINGS.YOU_REJECTED_CHANGES_FOR} ${item.details.eventTitle}`
                                : `${NOTIFICATION_STRINGS.YOU_ACCEPTED_CHANGES_FOR} ${item.details.eventTitle}`}
                          </Text>
                        </View>
                      ) : (item.actionType === "checkin_failed" ||
                        item.actionType === "no_challenger_selected" ||
                        item.actionType === "no_response") ? (
                        <View
                          style={{
                            flexDirection: "column",
                            maxWidth:
                              deviceSize === DEVICE_SIZES.SM ||
                                deviceSize === DEVICE_SIZES.XS
                                ? 200
                                : 600,
                            gap: 8,
                          }}
                        >
                          <Text
                            style={[
                              styles.strongText,
                              { color: AppColors.white },
                            ]}
                          >
                            {`Event Cancelled: ${item?.details?.cancelReason || item?.message || 'Event has been cancelled'}`}
                          </Text>
                          <Text
                            style={[
                              styles.normalText,
                              { color: AppColors.gray_C4C4C4 },
                            ]}
                          >
                            {`${NOTIFICATION_STRINGS.CHECK_OUT_DETAILS_OF_THE_EVENT} ${item.details.eventTitle}`}
                          </Text>
                        </View>
                      ) : item.actionType === "audience-alert" ? (
                        <View
                          style={{
                            flexDirection: "column",
                            maxWidth:
                              deviceSize === DEVICE_SIZES.SM ||
                                deviceSize === DEVICE_SIZES.XS
                                ? 200
                                : 600,
                            gap: 8,
                          }}
                        >
                          <Text
                            style={[
                              styles.strongText,
                              { color: AppColors.white },
                            ]}
                          >
                            {item.actionStatus === "completed"
                              ? item?.message
                              : item.notificationKey ===
                                "audience-pending-confirmation"
                                ? NOTIFICATION_STRINGS.AUDIENCE_ALERT_PENDING_TITLE
                                : NOTIFICATION_STRINGS.AUDIENCE_ALERT_CANCELED_TITLE}
                          </Text>
                          <Text
                            style={[
                              styles.normalText,
                              { color: AppColors.gray_C4C4C4 },
                            ]}
                          >
                            {item.actionStatus === "completed"
                              ? `${NOTIFICATION_STRINGS.CHECK_OUT_DETAILS_OF_THE_EVENT} ${item.details.eventTitle}`
                              : item.notificationKey ===
                                "audience-pending-confirmation"
                                ? NOTIFICATION_STRINGS.AUDIENCE_ALERT_PENDING_MESSAGE
                                : NOTIFICATION_STRINGS.AUDIENCE_ALERT_CANCELED_MESSAGE}
                          </Text>
                          {item.actionStatus === "completed" && winnerComponent}
                        </View>
                      ) : item?.category === "completed" ? (
                        <View
                          style={{
                            flexDirection: "column",
                            maxWidth:
                              deviceSize === DEVICE_SIZES.SM ||
                                deviceSize === DEVICE_SIZES.XS
                                ? 200
                                : 600,
                            gap: 8,
                          }}
                        >
                          <Text
                            style={[
                              styles.strongText,
                              { color: AppColors.white },
                            ]}
                          >
                            {item?.message}
                          </Text>
                          <Text
                            style={[
                              styles.normalText,
                              { color: AppColors.gray_C4C4C4 },
                            ]}
                          >
                            {`${NOTIFICATION_STRINGS.CHECK_OUT_DETAILS_OF_THE_EVENT} ${item.details.eventTitle}`}
                          </Text>
                          {winnerComponent}
                        </View>
                      ) : null
                    ) : selectedButton === "Im Watching" ? (
                      <View
                        style={{
                          alignItems: "flex-start",
                          maxWidth:
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? 200
                              : 575,
                        }}
                      >
                        <Text style={{ color: AppColors.white }}>
                          <Text style={[styles.strongText]}>
                            {item?.details?.gameTitle}&nbsp;
                          </Text>
                          {(item.actionType === "checkin_failed" ||
                            item.actionType === "no_challenger_selected" ||
                            item.actionType === "no_response") ? (
                            <Text style={[styles.normalText]}>
                              {NOTIFICATION_STRINGS.HAS_BEEN_CANCELLED}
                            </Text>
                          ) : (
                            <Text style={[styles.normalText]}>
                              : {item?.message}
                            </Text>
                          )}
                        </Text>
                        <Text
                          style={[
                            styles.normalText,
                            {
                              color: AppColors.gray_C4C4C4,
                              maxWidth:
                                deviceSize === DEVICE_SIZES.SM ||
                                  deviceSize === DEVICE_SIZES.XS
                                  ? 200
                                  : 575,
                            },
                          ]}
                          numberOfLines={1}
                          ellipsizeMode="tail"
                        >
                          {`${NOTIFICATION_STRINGS.CHECK_OUT_DETAILS_OF_THE_EVENT_IM_WATCHING}${item.details.eventTitle}`}
                        </Text>
                      </View>
                    ) : null}
                  </View>
                  <View
                    style={{
                      alignContent: "flex-end",
                      flex: 1,
                      flexDirection: "row",
                      gap: 8,
                    }}
                  >
                    <View
                      style={{
                        alignContent: "flex-start",
                        flex: 2,
                        gap:
                          deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.XS
                            ? 5
                            : 8,
                      }}
                    >
                      <Text style={[styles.timeText]}>
                        {formatDate(item?.createdAt)}
                      </Text>
                    </View>
                    <View
                      style={{
                        width:
                          deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.XS
                            ? 20
                            : 30,
                        height:
                          deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.XS
                            ? 20
                            : 30,
                        borderRadius:
                          deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.XS
                            ? 4
                            : 6,
                        borderWidth:
                          deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.XS
                            ? 0.5
                            : 1,
                        padding:
                          deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.XS
                            ? 4
                            : 7,
                        alignContent: "flex-end",
                        backgroundColor: AppColors.gray_212222,
                      }}
                    >
                      <TouchableOpacity
                        onPress={() => {
                          setIsRemoving(true);
                          Animated.timing(fadeAnim, {
                            toValue: 0,
                            duration: 300,
                            useNativeDriver: true,
                          }).start(() => {
                            handleNotificationResponse(item.notificationId);
                          });
                        }}
                        style={{ position: "static", right: 0 }}
                      >
                        <Image
                          source={AppImages.icClose}
                          style={{
                            height:
                              deviceSize === DEVICE_SIZES.SM ||
                                deviceSize === DEVICE_SIZES.XS
                                ? 12
                                : 16,
                            width:
                              deviceSize === DEVICE_SIZES.SM ||
                                deviceSize === DEVICE_SIZES.XS
                                ? 12
                                : 16,
                            alignSelf: "center",
                          }}
                          resizeMode="contain"
                        />
                      </TouchableOpacity>
                    </View>
                  </View>
                </View>
              </View>
              <View
                style={{
                  height:
                    deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                      ? 20
                      : 38,
                  flexDirection: "row",
                  gap:
                    deviceSize === DEVICE_SIZES.SM ||
                      deviceSize === DEVICE_SIZES.XS
                      ? 8
                      : 16,
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <View
                  style={{
                    flexDirection: "row",
                    gap:
                      deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                        ? 8
                        : 22,
                    height:
                      deviceSize === DEVICE_SIZES.SM ||
                        deviceSize === DEVICE_SIZES.XS
                        ? 20
                        : 38,
                  }}
                >
                  <NotificationButtons
                    item={item}
                    navigation={navigation}
                    selectedButton={selectedButton}
                    setShowPendingNotifications={setShowPendingNotifications}
                    setChallengeItem={setChallengeItem}
                    challengeID={challengeID}
                    setChallengeID={setChallengeID}
                    setShowNotificationDetails={setShowNotificationDetails}
                    accessToken={accessToken}
                    noTimeLeft={noTimeLeft}
                    setConfirmCheckInLoader={setConfirmCheckInLoader}
                    confirmCheckInLoader={confirmCheckInLoader}
                    getNotificationList={getNotificationList}
                    setChallengeDetails={setChallengeDetails}
                    setUpdatedEventDetails={setUpdatedEventDetails}
                    setPreviousEventDetails={setPreviousEventDetails}
                    setUpdatedEventEventId={setUpdatedEventEventId}
                    setUpdatedEventNotificationId={
                      setUpdatedEventNotificationId
                    }
                    setShowEventsDetailsUpdatedModal={
                      setShowEventsDetailsUpdatedModal
                    }
                    setShowChangesApprovedModal={setShowChangesApprovedModal}
                    setShowChangesRejectedModal={setShowChangesRejectedModal}
                    showChangesLoader={showChangesLoader}
                    challengeDetails={challengeDetails}
                    setShowAcceptModal={setShowAcceptModal}
                    showAcceptModal={showAcceptModal}
                    setCornfirmPurchaseBeltModal={setCornfirmPurchaseBeltModal}
                    setAcceptLoader={setAcceptLoader}
                    handleProfileUpdate={handleProfileUpdate}
                    isMissed={isMissed}
                    markAsSeenById={markAsSeenById}
                    refreshCounts={refreshCounts}
                    updateNotificationStatus={updateNotificationStatus}
                  />
                </View>
                {((selectedButton === "Challenges" &&
                  item?.details?.eventType === "Private") ||
                  (selectedButton === "Im Watching" &&
                    !(item.actionType === "checkin_failed" ||
                      item.actionType === "no_challenger_selected" ||
                      item.actionType === "no_response") &&
                    item?.type !== "event_update_attendee" &&
                    item?.category !== "watching-reminder" &&
                    item.actionType !== "audience-alert")) &&
                  !(
                    (item.actionType === "check-in" ||
                      item.actionType === "attendance-reminder") &&
                    item.actionStatus === "confirmed"
                  ) ? (
                  <View
                    style={{
                      justifyContent: "center",
                      gap:
                        deviceSize === DEVICE_SIZES.SM ||
                          deviceSize === DEVICE_SIZES.XS
                          ? 5
                          : 20,
                    }}
                  >
                    <CardProgressBar
                      showProgressBar={selectedButton !== "Im Watching"}
                      size={
                        deviceSize === DEVICE_SIZES.SM ||
                          deviceSize === DEVICE_SIZES.XS
                          ? 26
                          : 45
                      }
                      width={5}
                      fill={item?.details?.attendeeCount}
                      tintColor={AppColors.red_AF0707}
                      label={`${NOTIFICATION_STRINGS.REMAINING_TIME}${timeLeft}`}
                      name={undefined}
                      fontStyle={AppFontStyle.SEMIBOLD_ANYBODY_10}
                      deviceSize={deviceSize}
                    />
                  </View>
                ) : selectedButton === "Im Watching" &&
                  (item.actionType === "checkin_failed" ||
                    item.actionType === "no_challenger_selected" ||
                    item.actionType === "no_response") ? (
                  <View
                    style={{
                      alignItems: "center",
                      justifyContent: "center",
                      gap:
                        deviceSize === DEVICE_SIZES.SM ||
                          deviceSize === DEVICE_SIZES.XS
                          ? 5
                          : 20,
                    }}
                  >
                    <Text
                      style={[
                        deviceSize === DEVICE_SIZES.SM ||
                          deviceSize === DEVICE_SIZES.XS
                          ? AppFontStyle.LIGHT_ANYBODY_8
                          : AppFontStyle.LIGHT_ANYBODY_12,
                        {
                          color: '#DC2626',
                          width:
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? 120
                              : 160,
                          textAlign: "center",
                          marginBottom:
                            deviceSize === DEVICE_SIZES.SM ||
                              deviceSize === DEVICE_SIZES.XS
                              ? 8
                              : 20,
                        },
                      ]}
                    >
                      {item?.details?.cancelReason || item?.message || 'Event cancelled'}
                    </Text>
                    <View
                      style={{
                        backgroundColor: AppColors.red_AF0707,
                        height:
                          deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.XS
                            ? 20
                            : 38,
                        width:
                          deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.XS
                            ? 80
                            : 140,
                        alignItems: "center",
                        justifyContent: "center",
                        borderRadius: 10,
                      }}
                    >
                      <Text
                        style={[
                          deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.XS
                            ? AppFontStyle.BOLD_ANYBODY_8
                            : AppFontStyle.BOLD_ANYBODY_12,
                          { color: AppColors.white },
                        ]}
                      >
                        {NOTIFICATION_STRINGS.EVENT_CANCELLED}
                      </Text>
                    </View>
                  </View>
                ) : null}
                {(selectedButton === "Challenges" ||
                  selectedButton === "I've Organised") &&
                  (item.actionType === "check-in" ||
                    item.actionType === "attendance-reminder") &&
                  item.actionStatus === "pending" &&
                  timeLeftUTC &&
                  !isMissed && (
                    <View
                      style={{
                        flexDirection: "row",
                        gap: 5,
                        justifyContent: "space-between",
                        bottom:
                          deviceSize === DEVICE_SIZES.SM ||
                            deviceSize === DEVICE_SIZES.XS
                            ? 10
                            : 20,
                      }}
                    >
                      {["days", "hours", "minutes", "seconds"].map(
                        (unit, index) => (
                          <View key={unit} style={{ alignItems: "center" }}>
                            <Text
                              style={[
                                deviceSize === DEVICE_SIZES.SM ||
                                  deviceSize === DEVICE_SIZES.XS
                                  ? AppFontStyle.SEMIBOLD_ANYBODY_10
                                  : AppFontStyle.REGULAR_ANYBODY_20,
                                {
                                  backgroundColor: AppColors.black,
                                  borderWidth: 1,
                                  borderColor: AppColors.white,
                                  padding:
                                    deviceSize === DEVICE_SIZES.SM ||
                                      deviceSize === DEVICE_SIZES.XS
                                      ? 4
                                      : 8,
                                  borderRadius:
                                    deviceSize === DEVICE_SIZES.SM ||
                                      deviceSize === DEVICE_SIZES.XS
                                      ? 4
                                      : 8,
                                  color: AppColors.white,
                                },
                              ]}
                            >
                              {timeLeftUTC[unit] < 10 ? "0" : ""}
                              {timeLeftUTC[unit]}
                            </Text>
                            <Text
                              style={[
                                deviceSize === DEVICE_SIZES.SM ||
                                  deviceSize === DEVICE_SIZES.XS
                                  ? AppFontStyle.SEMIBOLD_ANYBODY_6
                                  : AppFontStyle.REGULAR_ANYBODY_12,
                                { color: AppColors.gray_C3C3C3, marginTop: 2 },
                              ]}
                            >
                              {NOTIFICATION_STRINGS[unit.toUpperCase()]}
                            </Text>
                          </View>
                        )
                      )}
                    </View>
                  )}
              </View>
            </Animated.View>
          )}
        </>
      )}
    </>
  );
}
export default withErrorBoundary(ChallengeItem);
export const useStyles = CreateResponsiveStyle(
  {
    playersView: { flexDirection: "row", gap: 30, alignSelf: "center" },
    playerView: { borderRadius: 12 },
    outerView: { flexDirection: "row" },
    imageComponentStyle: {
      height: 60,
      width: 60,
      borderColor: AppColors.white_C1C1C1,
      borderWidth: 1,
      borderRadius: 15,
    },
    strongText: { fontWeight: "bold", fontSize: 20 },
    normalText: {
      fontSize: 16,
      fontWeight: "normal",
      color: AppColors.grayColor_999999,
    },
    timeText: {
      fontSize: 14,
      fontWeight: "light",
      alignSelf: "flex-end",
      color: AppColors.white_D2D2D2,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {
      strongText: { fontWeight: "bold", fontSize: 14 },
      normalText: {
        fontSize: 12,
        fontWeight: "normal",
        color: AppColors.grayColor_999999,
      },
      imageComponentStyle: {
        height: 40,
        width: 40,
        borderColor: AppColors.white_C1C1C1,
        borderWidth: 1,
        borderRadius: 10,
      },
      timeText: { fontSize: 10 },
    },
    [DEVICE_SIZES.XS]: {
      strongText: { fontWeight: "bold", fontSize: 12 },
      normalText: {
        fontSize: 10,
        fontWeight: "normal",
        color: AppColors.grayColor_999999,
      },
      imageComponentStyle: {
        height: 36,
        width: 36,
        borderColor: AppColors.white_C1C1C1,
        borderWidth: 1,
        borderRadius: 9,
      },
      timeText: { fontSize: 8 },
    },
  }
);
